<div class="my-orders-container">
  <mat-tab-group
    mat-stretch-tabs
    mat-align-tabs="center"
    preserveContent="true"
    animationDuration="100"
    #myOrdersTabGroup
    [(selectedIndex)]="selectedIndex"
  >
    <!-- Waiting for payment -->
    <mat-tab label="در انتظار پرداخت">
      <div
        class="payments"
        *ngIf="paymentPagination && finalizedPayments?.length"
      >
        <app-payment-review
          *ngFor="let payment of finalizedPayments"
          [payment]="payment"
          (onCancel)="cancelPayment($event)"
        />
      </div>
      <div
        *ngIf="!paymentPagination || !finalizedPayments?.length"
        class="no-element"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/empty-box-2.svg" alt="" />
        <span class="disabled"> خیلی متاسفیم، چیزی پیدا نشد!</span>
      </div>
    </mat-tab>

    <mat-tab label="در حال پردازش">
      <div
        class="payments"
        *ngIf="paymentPagination && progressPayments?.length"
      >
        <app-payment-review
          *ngFor="let payment of progressPayments"
          [payment]="payment"
        ></app-payment-review>
      </div>

      <div
        *ngIf="!progressPayments?.length"
        class="no-element"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/empty-box-2.svg" alt="" />
        <span class="disabled"> خیلی متاسفیم، چیزی پیدا نشد!</span>
      </div>
    </mat-tab>

    <mat-tab label="سفارشات پیشین">
      <div
        class="payments"
        *ngIf="paymentPagination && deliveredPayments?.length"
      >
        <app-payment-review
          style="cursor: pointer"
          *ngFor="let payment of deliveredPayments"
          [payment]="payment"
        ></app-payment-review>
      </div>
      <div
        *ngIf="!paymentPagination || !deliveredPayments?.length"
        class="no-element"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/empty-box-2.svg" alt="" />
        <span class="disabled"> خیلی متاسفیم، چیزی پیدا نشد!</span>
      </div>
    </mat-tab>

    <mat-tab label="سفارشات لغو شده">
      <div
        class="payments"
        *ngIf="paymentPagination && canceledPayments?.length"
      >
        <app-payment-review
          style="cursor: pointer"
          [routerLink]="[payment.factorNumber]"
          *ngFor="let payment of canceledPayments"
          [payment]="payment"
        ></app-payment-review>
      </div>
      <div
        *ngIf="!paymentPagination || !canceledPayments?.length"
        class="no-element"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <img src="../../../../../assets/image/empty-box-2.svg" alt="" />
        <span class="disabled"> خیلی متاسفیم، چیزی پیدا نشد!</span>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
